import React from "react";
import {
  Box,
  Grid,
  Typography,
  IconButton,
  Button,
  Stack,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { Icon } from "@iconify/react";
import { IoDocumentTextOutline } from "react-icons/io5";
import { MdOutlineFileDownload } from "react-icons/md";
import UploadAssignmentForm from "./UploadAssignmentForm";
import GlobalCustomPopup from "../../../../components/customPopup/GlobalCustomPopup";
import SubmissionCard from "./components/SubmissionCard";
import { fDate } from "../../../../../utils2/formatTime";

export default function ViewSubmission({ handleClose, selectedData,setSelectedData,setFilteredData }) {
  const [openUploadModal, setOpenUploadModal] = React.useState(false);
  const [selectedFile, setSelectedFile] = React.useState(null);

const  [fileName, setFileName] = React.useState(selectedData?.submitted_detail?.assignment_object?.original_filename);
const [downloadLink, setDownloadLink] = React.useState(selectedData?.submitted_detail?.assignment_link);


  const handleOpenUploadModal = (item) => {
    setOpenUploadModal(true);
    setSelectedFile(item);
  };

  const handleCloseUploadModal = () => {
    setOpenUploadModal(false);
  };

  return (
    <>
      <Box
        sx={{
          mt: 2,
          overflow: "hidden",
          fontFamily: "Inter",
        }}
      >
        {/* ================= CONTENT ================= */}
        <Box>
          {/* Info Cards */}
          <Box
            display="flex"
            flexWrap="wrap"
            //    gap={2}
            justifyContent="space-evenly"
            rowGap={1}
          >
            <SubmissionCard label="Test Type" value={selectedData?.test_type_id?.name} icon="mdi:file-document-outline" iconSize={20}/>
            <SubmissionCard label="Module" value={selectedData?.assignment_type} icon="mdi:book-outline" iconSize={18}/>
            <SubmissionCard label="Trainer Name" value={selectedData?.trainer_id?.first_name} icon="mdi:account-outline" iconSize={22}/>
            <SubmissionCard label="Due Date" value={selectedData?.due_date} icon="mdi:calendar-clock" iconSize={20}/>
            <SubmissionCard label="Submitted Date" value={fDate (selectedData?.submitted_detail?.submitted_date)} icon="mdi:calendar-check-outline" iconSize={20}/>
            <SubmissionCard label="Marks" value={selectedData?.max_marks} icon="mdi:star-outline" iconSize={18}/>

          
              {/* <Paper
                key={index}
                elevation={0}
                sx={{
                  background: "#FFFCE0",
                  borderRadius: "10px",
                  p: 1.5,
                  border: "1px solid #F2ECBD",
            
                }}
              >
                <Box display="flex" alignItems="center" gap={0.5}>
                  <Icon
                    icon={iconMap[item.label]?.icon}
                    width={iconMap[item.label]?.width || 20}
                    height={iconMap[item.label]?.width || 20}
                  />
                  <Typography fontSize="13px" fontWeight={700} color="#161719">
                    {item.label}
                  </Typography>
                </Box>

                <Typography
                  fontSize="13px"
                  fontWeight={600}
                  mt={0.5}
                  color="#572575"
                >
                  {item.value}
                </Typography>
              </Paper> */}
           
          </Box>

          {/* ================= SUBMISSION SECTION ================= */}
          <Typography
            mt={4}
            mb={2}
            fontWeight={600}
            fontSize="16px"
            color="#161719"
          >
            Assignment Submission
          </Typography>

          <Stack spacing={2}>
         
              <Paper
             
                elevation={0}
                sx={{
                  p: 2,
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  background: "#FEFEFE",
                  border: "1px solid #D9D9D9",
                  boxShadow: "0px 0px 7px 0px #00000026",

                }}
              >
                {/* File Name */}
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  color="#572575"
                >
                  <IoDocumentTextOutline sx={{ color: "572575" }} size={25} />
                  <Typography fontSize="14px" fontWeight={500}>
                   {fileName}
                  </Typography>
                </Stack>

                {/* Actions */}
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Button
                    size="small"
                    startIcon={<MdOutlineFileDownload />}
                    onClick={()=>window.open(downloadLink,"_blank")}
                    style={{
                      textTransform: "none",
                      background: "#F3E5F5",
                      color: "#650C72",
                      borderRadius: "8px",
                      padding: "4px 8px",
                      fontSize: "12px",
                    }}
                  >
                    Download
                  </Button>

{selectedData?.status!== "Graded" && ( 
                  <Button
                    size="small"
                    startIcon={<AutorenewIcon />}
                    style={{
                      textTransform: "none",
                      background: "#E3F2FD",
                      color: "#0F4973",
                      borderRadius: "8px",
                      padding: "4px 8px",
                    }}
                     onClick={() => handleOpenUploadModal(selectedData)}
                  >
                    Replace
                  </Button>
                  )}

                  {/* <IconButton
                                        size="small"
                                        // onClick={() => handleRemove(index)}
                                        style={{
                                          background: "#CE0E00",
                                          "&:hover": { background: "#FFCCCC" },
                                          width: 18,
                                          height: 18,
                                        }}
                                      >
                                        <CloseIcon style={{ color: "#EEEEEE", fontSize: 16 }} />
                                      </IconButton> */}
                </Stack>
              </Paper>
     
          </Stack>

        
        </Box>
      </Box>

      <GlobalCustomPopup
        handleClose={handleCloseUploadModal}
        component={
          <UploadAssignmentForm
            handleClose={handleCloseUploadModal}
            selectedData={selectedFile}
            fileName={fileName}
            setFileName={setFileName}
            setDownloadLink={setDownloadLink}
            setSelectedData={setSelectedData}
            setFilteredData={setFilteredData}
            // handleOpenSuccessPopup={handleOpenSuccessPopup}
          />
        }
        open={openUploadModal}
        title="Replace Assignment"
        titleColor="#FFFFFF"
        maxWidth="sm"
        titleAlign="start"
      />
    </>
  );
}
